import { Icon } from '@zambezi/sdk/icons';
import React from 'react';
import ScreenReaderOnly from '../ScreenReaderOnly/ScreenReaderOnly';
import './InlineError.scss';

interface InlineErrorProps extends React.HTMLProps<HTMLParagraphElement> {
  error: string;
  id: string;
}

const InlineError = ({ error, id }: InlineErrorProps) => {
  return (
    <p className="mss-field-error" id={`error-${id}`}>
      <Icon name="core-notification-error-small" size="xsmall" title="" />
      <ScreenReaderOnly>Error: </ScreenReaderOnly>
      {error}
    </p>
  );
};

export default InlineError;
